/* ==========================================================
   Auvelis slide-in cart
   Public API: window.AuvCart.open() / .close() / .add(id, qty) / .refresh()
   Also suppresses the theme's native cart drawer.
   ========================================================== */
(function () {
  var root, body, subtotalEl, countEl;

  function money(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function cache() {
    root = document.getElementById('auv-cart');
    if (!root) return false;
    body = root.querySelector('[data-cart-body]');
    subtotalEl = root.querySelector('[data-cart-subtotal]');
    countEl = root.querySelector('[data-cart-count]');
    return true;
  }

  function open() {
    if (!root && !cache()) return;
    closeNative();
    root.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
    document.body.style.overflow = 'hidden';
    refresh();
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (root && !root.classList.contains('is-open')) root.hidden = true;
    }, 380);
  }

  var NATIVE = [
    'cart-drawer-component',
    'dialog#cart-drawer',
    '#cart-drawer',
    '.cart-drawer',
    '[id*="cart-drawer"]'
  ].join(',');

  function closeNative() {
    document.querySelectorAll(NATIVE).forEach(function (el) {
      try {
        if (typeof el.close === 'function' && el.open) el.close();
        if (el.hasAttribute('open')) el.removeAttribute('open');
        el.classList.remove('is-open', 'active', 'open');
        el.setAttribute('aria-hidden', 'true');
        el.style.display = 'none';
      } catch (e) { /* ignore */ }
    });
    document.documentElement.classList.remove('cart-drawer-open', 'overflow-hidden');
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function render(cart) {
    if (!body) return;

    if (countEl) countEl.textContent = cart.item_count || 0;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="auv-cart__empty">'
        + '<strong>Your cart is empty</strong>'
        + '<span>Pick a bundle and it will show up here.</span>'
        + '<a href="/collections/all">Browse the collection</a>'
        + '</div>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item, i) {
      var img = item.image
        ? '<img src="' + esc(item.image) + '" alt="" width="140" height="140" loading="lazy">'
        : '';

      var variantPill = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantPill = '<span class="auv-li__pill">' + esc(item.variant_title) + '</span>';
      }

      /* show a saving when the variant carries a compare-at price */
      var saved = '';
      if (item.original_line_price > item.final_line_price) {
        saved = '<span class="auv-li__saved">Saved '
          + money(item.original_line_price - item.final_line_price) + '</span>';
      }

      var each = '';
      if (item.quantity > 1) {
        each = '<span class="auv-li__each">' + money(item.final_price) + ' each</span>';
      }

      html += ''
        + '<div class="auv-li" data-line="' + (i + 1) + '">'
        +   '<a class="auv-li__media" href="' + esc(item.url) + '">' + img + '</a>'
        +   '<div class="auv-li__main">'
        +     '<div class="auv-li__top">'
        +       '<a class="auv-li__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>'
        +       '<span class="auv-li__total">' + money(item.final_line_price) + '</span>'
        +     '</div>'
        +     '<div class="auv-li__tags">' + variantPill + saved + '</div>'
        +     '<div class="auv-li__bottom">'
        +       '<span class="auv-li__stepper">'
        +         '<button type="button" data-qty-down aria-label="Decrease quantity">'
        +           '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 12h12"/></svg>'
        +         '</button>'
        +         '<span class="auv-li__qty">' + item.quantity + '</span>'
        +         '<button type="button" data-qty-up aria-label="Increase quantity">'
        +           '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 6v12M6 12h12"/></svg>'
        +         '</button>'
        +       '</span>'
        +       each
        +       '<button type="button" class="auv-li__remove" data-remove aria-label="Remove">'
        +         '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M9 7V5h6v2"/><path d="M6 7l1 13h10l1-13"/></svg>'
        +       '</button>'
        +     '</div>'
        +   '</div>'
        + '</div>';
    });
    body.innerHTML = html;
  }

  function refresh() {
    if (!root && !cache()) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        syncHeaderCount(cart.item_count);
        return cart;
      })
      .catch(function () {
        if (body) body.innerHTML = '<div class="auv-cart__empty">Could not load your cart.</div>';
      });
  }

  function syncHeaderCount(n) {
    document.querySelectorAll('.cart-bubble__background, [data-cart-bubble-count], .cart-count').forEach(function (el) {
      el.textContent = n;
    });
  }

  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); syncHeaderCount(cart.item_count); });
  }

  function add(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (res) {
      open();
      return res;
    });
  }

  function isCartTrigger(target) {
    if (!target || !target.closest) return false;
    if (target.closest('[data-auv-no-cart]')) return false;
    if (target.closest('#auv-cart')) return false;

    var link = target.closest('a[href]');
    if (link) {
      var href = link.getAttribute('href') || '';
      if (href.indexOf('/cart/add') === -1 && /\/cart(\/|\?|$)/.test(href)) return true;
    }

    if (target.closest('[aria-controls*="cart-drawer"]')) return true;
    if (target.closest('[data-cart-toggle]')) return true;
    if (target.closest('.header__cart, .header-actions__cart, [class*="cart-icon"]')) return true;

    return false;
  }

  function bind() {
    if (!cache()) return;

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { close(); return; }

      var itemEl = e.target.closest('.auv-li');
      if (!itemEl) return;
      var line = parseInt(itemEl.getAttribute('data-line'), 10);
      var valEl = itemEl.querySelector('.auv-li__qty');
      var current = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;

      if (e.target.closest('[data-qty-up]')) { changeLine(line, current + 1); }
      else if (e.target.closest('[data-qty-down]')) { changeLine(line, Math.max(0, current - 1)); }
      else if (e.target.closest('[data-remove]')) { changeLine(line, 0); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && root.classList.contains('is-open')) close();
    });

    document.addEventListener('click', function (e) {
      if (isCartTrigger(e.target)) {
        e.preventDefault();
        e.stopPropagation();
        open();
      }
    }, true);

    closeNative();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        var native = document.querySelector(NATIVE);
        if (!native) return;
        var looksOpen = native.open
          || native.hasAttribute('open')
          || native.classList.contains('is-open')
          || native.classList.contains('active');
        if (looksOpen) { closeNative(); open(); }
      });
      mo.observe(document.documentElement, {
        attributes: true,
        subtree: true,
        attributeFilter: ['open', 'class', 'aria-hidden']
      });
    }
  }

  window.AuvCart = { open: open, close: close, refresh: refresh, add: add };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
